<template>
    <div class="attachment-container">
        <div class="attachment-content" v-html="content"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            content: ''
        };
    },
    mounted() {
        document.title = '附件内容';
        const content = sessionStorage.getItem('exam_attachment_content');
        if (content) {
            this.content = content;
        }
    }
}
</script>
<style lang="scss" scoped>
.attachment-container {
    padding: 20px;
    font-family: 'Microsoft YaHei', sans-serif;
    line-height: 1.6;
    color: #333;
    max-width: 1200px;
    margin: 0 auto;
}
.attachment-content {
    ::v-deep img {
        max-width: 100%;
        height: auto;
    }
}
</style>